// 人物信息页面翻译
export default {
  // 输入框占位符
  placeholders: {
    name: "请输入姓名",
    homePlace: "请输入籍贯",
    suspicionLevel: "请选择嫌疑程度",
    idNumber: "请输入身份证号",
    role: "请输入角色",
    phone: "请输入手机号，多个用逗号隔开",
    email: "请输入邮箱，多个用逗号隔开",
    caseSearch: "请输入案件名称查询并选择案件，可多选",
    surveySearch: "请输入调证用户ID查询并选择调证用户，可多选",
    traceJudgment: "请输入轨迹研判",
    infoStreamJudgment: "请输入信息流研判",
    assetJudgment: "请输入资产流研判",
    phoneListInfo: "请输入手机列装情况",
    companyUnderName: "请选择名下公司情况",
    actualControlAddress: "请输入实控地址",
    chineseIdentity: "请输入身份",
    remark: "请输入备注",
    region: "请选择地区",
  },

  // 按钮
  buttons: {
    reset: "重置",
    search: "查询",
    addCharacter: "添加人物",
    view: "查看",
    delete: "删除",
    cancel: "取消",
    confirm: "确认",
    edit: "编辑",
    save: "保存",
    duplicateCheck: "重复校验",
    goEdit: "去编辑",
  },

  // 统计信息
  statistics: {
    total: "共计",
    totalData: "条数据",
  },

  // 表格列标题
  table: {
    name: "姓名",
    homePlace: "籍贯",
    suspicionLevel: "嫌疑程度",
    traceJudgment: "轨迹研判",
    infoStreamJudgment: "信息流研判",
    assetJudgment: "资产流研判",
    sourceType: "数据来源",
    updateTime: "更新时间",
    action: "操作",
  },

  // 对话框标题
  dialogs: {
    detail: "人物详情",
    create: "新增人物",
    edit: "人物编辑",
    deleteConfirm: "删除确认",
    deleteMessage: "此操作将永久删除{name}人物信息，是否确定?",
    duplicateWarning: "提示",
    duplicateMessage:
      '当前身份证号已存在人物信息，人物姓名为"{name}"，请确认是否需要编辑该人物信息？',
  },

  // 表单标签
  labels: {
    name: "姓名",
    region: "地区",
    suspicionLevel: "嫌疑程度",
    idNumber: "身份证号",
    homePlace: "籍贯",
    role: "角色",
    phone: "手机号",
    email: "邮箱",
    gcCase: "图链案件",
    backendCase: "后台case",
    relatedSurvey: "关联调证",
    traceJudgment: "轨迹研判",
    infoStreamJudgment: "信息流研判",
    assetJudgment: "资产流研判",
    phoneListInfo: "手机列装情况",
    companyUnderName: "名下公司",
    actualControlAddress: "实控地址",
    chineseIdentity: "中国身份",
    remark: "备注",
    updateTime: "更新时间",
    lastOperator: "最近操作人",
    sourceType: "数据来源",
    // 编辑页面特有标签（调证/人工分类）
    phoneSurvey: "手机号(调证)",
    phoneManual: "手机号(人工)",
    emailSurvey: "邮箱(调证)",
    emailManual: "邮箱(人工)",
    gcCaseSurvey: "图链案件(调证)",
    gcCaseManual: "图链案件(人工)",
    relatedSurveySurvey: "关联调证(调证)",
    relatedSurveyManual: "关联调证(人工)",
  },

  // 提示信息
  messages: {
    noData: "暂无数据",
    loading: "拼命加载中",
    deleteSuccess: "删除成功",
    deleteCancelled: "已取消删除",
    createSuccess: "新增成功",
    createFailed: "新增失败",
    editSuccess: "编辑成功",
    editFailed: "编辑失败",
    saveFailed: "保存失败，请稍后再试",
    checkFailed: "校验失败，请稍后再试",
    enterIdFirst: "请先输入身份证号",
    fetchFailed: "获取人物信息失败",
  },
};
